export default __webpack_public_path__ + "static/media/odsIcon.11bab463.svg";